<template>
    <div class="payment-methods-body">
        <div class="payment-methods-title">
            料金のお支払い方法
        </div>
        <div class="images-area">
            <img :src="paymentImages[0]"/>
        </div>
        <div class="payment-methods-text">
            <p>1.左下の【メニュー】<br/>を選択</p>
            <p>2.【マイページ】を選択</p>
        </div>
        <div class="images-area">
            <img :src="paymentImages[1]"/>
        </div>
        <div class="payment-methods-text">
            <p>3.【購入】を選択</p>
            <p>4.ご希望のプランをお選びいただき、【購入】を選択</p>
        </div>
    </div>
</template>
<script>
import payment0 from '../../../images/payment0.png'
import payment1 from '../../../images/payment1.png'
export default {
    data () {
        return {
            paymentImages: [
                payment0,
                payment1
            ]
        }
    }
}
</script>
<style scoped>
.payment-methods-body {
    padding-top: 60px;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 30px;
}
.payment-methods-title {
    text-align: center;
    font-size: 26px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: bold;
    color: #000000;
    margin-bottom: 20px;
}
.images-area {
    width: 100%;
    padding-left: 20px;
}
.images-area img {
    display: block;
    height: 240px;
}
.payment-methods-text {
    padding-top: 10px;
    padding-left: 20px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
}
.payment-methods-text p {
    flex: 1;
    box-sizing: border-box;
    padding-right: 30px;
    font-size: 12px;
    font-family: A-OTF Gothic MB101 Pro;
    font-weight: normal;
    color: #010101;
}
</style>